if(!customElements.get('image-modal')) {
  class ComponentImageModal extends HTMLElement {
    constructor() {
      super();
      this.openBtn = this.querySelector('.btn-image-modal');
      this.targetModal = this.querySelector('.target-modal');
      this.openBtn.addEventListener('click', ()=>{
        $s.openModal(this.targetModal, 'modal-single-image');
      });

    }



  }
  customElements.define('image-modal', ComponentImageModal);
}